import React, {Component} from 'react'
import PropTypes from "prop-types";
import Error from "../single_components/Error";
import {makeError} from "../modals/ErrorModal";
import SvGraphics from "../../assets/SvGraphics";
import {OverlayTrigger} from "react-bootstrap";
import Popover from "react-bootstrap/Popover";

class SelfLifestyle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            checkboxes: this.props.checkboxes,
            drive:false,
            work:false,
            learn:false,
            smoke:false,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }
    componentDidMount() {
        this.setState({drive: this.state.entry.Driving==="Yes"})
        this.setState({work: this.state.entry.Employment_details==="Work"})
        this.setState({learn: this.state.entry.Employment_details==="Learn"})
        this.setState({smoke: this.state.entry.Smoker==="Yes"})
    }

    onclickDrive(value){
        let {entry}=this.state
        this.props.onYesNoValueChange("Driving", value)

        if(entry.Driving==="No"){
            this.props.onValueChange("Commercial_license", "")
        }
    }
    async onclickCommercialLicense(value) {
        this.props.onYesNoValueChange("Commercial_license", value)
        let {t} =this.props
        if (value === "Yes") {
            await makeError({
                proceedLabel: t('patient_self_boarding.ok'),
            }, ['יש חובת דיווח למרב"ד']);
            return;
        }
    }

    onclickEmployment(event){
        this.setState({work: event.target.value === "Work"})
        this.setState({learn: event.target.value === "Learn"})
        this.props.onValueChange("Employment_details", event.target.value)

    }
    onclickSmoke(event){
        this.setState({smoke: event.target.value === "Yes"})
        this.props.onValueChange("Smoker", event.target.value)

    }

    onclickEmploymentType(event){
        this.props.onValueChange("work_type", event.target.value)
        if(event.target.value!=="Other"){
            this.props.onValueChange("other_work_type", "")
        }
    }

    render() {
        let {entry,checkboxes}= this.state
        let {t} = this.props
        return (
            <div className={'patientsFormBoxes'}>


                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>

                            <label className={'infoLabel-withError'}>{t('patient_self_boarding.drive')}?*</label>
                            <Error isShown={!!(this.props.errors)['Driving']} errorMessage={(this.props.errors)['Driving']}/>
                        </div>
                        <button tabIndex={0}  className={entry.Driving==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.onclickDrive("Yes")}>{t('patient_self_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Driving==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.onclickDrive("No")}>{t('patient_self_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

                <div className={'patientsFormRow'} style={{ display: entry.Driving==="Yes" ?'block': 'none' }}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_self_boarding.CommercialLicense')}?*</label>
                            <Error isShown={!!(this.props.errors)['Commercial_license']} errorMessage={(this.props.errors)['Commercial_license']}/>
                        </div>
                        <button tabIndex={0}  className={entry.Commercial_license==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.onclickCommercialLicense("Yes")}>{t('patient_self_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Commercial_license==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.onclickCommercialLicense("No")}>{t('patient_self_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_self_boarding.weapon_license')}?</label>
                        </div>
                        <button tabIndex={0}  className={entry.Ministry_Interior_matters==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Ministry_Interior_matters","Yes")}>{t('patient_self_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Ministry_Interior_matters==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Ministry_Interior_matters","No")}>{t('patient_self_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.Study')}</label>
                        <select className={'selectBox'} id="Work" name="EmploymentDetails" value={entry.Employment_details} onChange={this.onclickEmployment.bind(this)}>
                            <option/>
                            <option value="Work">{t('patient_self_boarding.Work')}</option>
                            <option value="Learn">{t('patient_self_boarding.Learn')}</option>
                            <option value="Retired">{t('patient_self_boarding.Retired')}</option>
                            <option value="Unemployed">{t('patient_self_boarding.Unemployed')}</option>
                            <option value="Homemaker">{t('patient_self_boarding.Homemaker')}</option>
                            <option value="Other">{t('patient_self_boarding.other')}</option>
                        </select>
                    </div>

                    <div className={'inputSlots'} style={{ display: entry.Employment_details==="Work" ?'block': 'none' }}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.occupation_type')}</label>
                        <select className={'selectBox'} id="Work" name="EmploymentDetails" value={entry.work_type}
                                onChange={this.onclickEmploymentType.bind(this)}
                            /*onChange={(event) => this.props.onValueChange("work_type", event.target.value)}*/>
                            <option value=""/>
                            <option value="work_office">{t('patient_self_boarding.work_office')}</option>
                            <option value="hand_work">{t('patient_self_boarding.hand_work')}</option>
                            <option value="risk_work">{t('patient_self_boarding.risk_work')}</option>
                            <option value="security_work">{t('patient_self_boarding.security_work')}</option>
                            <option value="drive_work">{t('patient_self_boarding.drive_work')}</option>
                            <option value="Other">{t('patient_self_boarding.other')}</option>
                        </select>
                    </div>
                    <div className={'inputSlots'} style={{ display: entry.work_type==="Other" ?'block': 'none' }}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.other')}</label>
                        <input className={'inputBoxStyle'} type="text"  name="other_work_type" defaultValue={entry.other_work_type}
                               onChange={(event) => this.props.onValueChange("other_work_type", event.target.value)}/>
                    </div>
                    {/*<div className={'inputSlots'} style={{ display: entry.Employment_details==="Work" ?'block': 'none' }}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.hoursWeek')}</label>
                        <input className={'inputBoxStyle'} type="number"  name="Weekly_working_hours" defaultValue={entry.Weekly_working_hours}
                               min={1} max={99}
                               onChange={(event) => this.props.onValueChange("Weekly_working_hours", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'} style={{ display: entry.Employment_details==="Learn" ?'block': 'none' }}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.hoursWeek')}</label>
                        <input className={'inputBoxStyle'} type="number"  name="Weekly_learning_hours" defaultValue={entry.Weekly_learning_hours}
                               min={1} max={99}
                               onChange={(event) => this.props.onValueChange("Weekly_learning_hours", event.target.value)}/>
                    </div>*/}
                </div>

                <div className={'patientsFormRow'} >
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.AlcoholUsage')}?</label>
                        <select className={'selectBox'} id="Work" name="AlcoholUsage" value={entry.Alcohol_usage}
                                onChange={(event) => this.props.onValueChange("Alcohol_usage", event.target.value)}>
                            <option/>
                            <option value="Never">{t('patient_self_boarding.AlcoholUsageNone')}</option>
                            <option value="-1M ">{t('patient_self_boarding.-1M')}</option>
                            <option value="2_4M">{t('patient_self_boarding.2_4M')}</option>
                            <option value="2_3W">{t('patient_self_boarding.2_3W')}</option>
                            <option value="4W">{t('patient_self_boarding.4W')}</option>
                        </select>
                    </div>

                </div>
                {entry.Alcohol_usage!=="Never" && entry.Alcohol_usage!==""&&<div className={'patientsFormRow'}>

                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_self_boarding.AlcoholDose')}? </label>

                            <OverlayTrigger
                                placement={"bottom"}
                                delay={{show: 250, hide: 250}}
                                trigger={"click"}
                                rootClose
                                overlay={
                                    <Popover id="popover-faqs">
                                        <Popover.Content>

                                            <div className={'faqs-element'}>
                                                <label className={'faqs-element-label'}>{t('patient_self_boarding.AlcoholDose_text')}</label>
                                            </div>
                                        </Popover.Content>
                                    </Popover>
                                }>
                                <SvGraphics svgname={'info-icon'} width={'35px'} height={'35px'}/>
                            </OverlayTrigger>
                        </div>


                        <select className={'selectBox'} id="AlcoholDose" name="AlcoholDose" value={entry.Alcohol_amount}
                                onChange={(event) => this.props.onValueChange("Alcohol_amount", event.target.value)}>
                            <option/>
                            <option value="1_2">{t('patient_self_boarding.1_2')}</option>
                            <option value="3_4 ">{t('patient_self_boarding.3_4')}</option>
                            <option value="5_6">{t('patient_self_boarding.5_6')}</option>
                            <option value="7_9">{t('patient_self_boarding.7_9')}</option>
                            <option value="10+">{t('patient_self_boarding.10+')}</option>
                        </select>
                    </div>
                </div>
                }
                <div className={'patientsFormRow'}>

                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.smoke')}? </label>
                        <select className={'selectBox'} id="Smoke" name="Smoke" value={entry.Smoker} onChange={this.onclickSmoke.bind(this)}>
                            <option/>
                            <option value="Yes">{t('patient_self_boarding.yes')}</option>
                            <option value="No">{t('patient_self_boarding.no_never')}</option>
                            <option value="SmokePast">{t('patient_self_boarding.no_past')}</option>
                        </select>
                    </div>
                    <div className={'inputSlots'} style={{ display: entry.Smoker==="Yes"?'block': 'none' }}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.Cigarettes')}? </label>
                        <select className={'selectBox'} id="Cigarettes" name="Cigarettes" value={entry.Smoking_amount}
                                onChange={(event) => this.props.onValueChange("Smoking_amount", event.target.value)}>
                            <option/>
                            <option value="10_Cigarettes">{t('patient_self_boarding.10_Cigarettes')}</option>
                            <option value="20_Cigarettes">{t('patient_self_boarding.20_Cigarettes')}</option>
                            <option value="more_Cigarettes">{t('patient_self_boarding.more_Cigarettes')}</option>
                        </select>
                    </div>

                </div>
            </div>

        )
    }
}

SelfLifestyle.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default SelfLifestyle;
